import { FunctionComponent, useMemo } from 'react';
import { CopyText } from '@foxtrotplatform/developer-platform-common-ui-component-lib';

import { APISubscriptionDetails } from '../types';

export interface SubscribedApiDetailWrapperProps {
  apiDetail: APISubscriptionDetails;
}

export const SubscribedApiDetailWrapper: FunctionComponent<
  SubscribedApiDetailWrapperProps
> = ({ apiDetail }) => {
  const renderDetails = useMemo(() => {
    if (apiDetail.details && apiDetail.details.length > 1) {
      return apiDetail.details.map(({ name, url }, i) => {
        const isBeginning = i === 0;
        return (
          <div
            className={`${
              isBeginning ? 'rounded-t-xl' : ''
            } grid grid-cols-5 py-4 px-9 justify-between items-center bg-primary-100`}
            key={i}
          >
            <div className="col-span-1 text-sm text-slate-700 font-bold capitalize">
              {name}
            </div>
            <a
              className="col-span-3 underline text-left 
          text-secondary-800 break-words active:text-purple-500 ease-linear transition-all duration-150 cursor-pointer bg-transparent text-sm outline-none focus:outline-none"
              href={url}
              target="_blank"
              rel="noreferrer"
            >
              {url}
            </a>
            <CopyText value={url} />
          </div>
        );
      });
    }
    return (
      <div className="grid grid-cols-5 py-4 px-9 justify-between items-center rounded-t-xl bg-primary-100">
        <div className="col-span-1 text-sm text-slate-700 font-bold">URL</div>
        <a
          className="col-span-3 underline text-left 
          text-secondary-800 break-words active:text-purple-500 ease-linear transition-all duration-150 cursor-pointer bg-transparent text-sm outline-none focus:outline-none"
          href={apiDetail.details[0].url}
          target="_blank"
          rel="noreferrer"
        >
          {apiDetail.details[0].url}
        </a>
        <CopyText value={apiDetail.details[0].url} />
      </div>
    );
  }, [apiDetail.details]);

  return (
    <div className="flex flex-col w-full">
      <div className="font-bold mb-4 mt-8">{apiDetail.name}</div>
      {renderDetails}
      <div className="grid grid-cols-5 py-4 px-9 justify-between items-center bg-primary-100">
        <div className="col-span-1 text-sm text-slate-700 font-bold">Key</div>
        <div className="col-span-3 text-sm text-slate-500 text-left break-words">
          {apiDetail.token}
        </div>
        <CopyText value={apiDetail.token} />
      </div>

      <div className="grid grid-cols-5 py-4 px-9 justify-between items-center rounded-b-xl bg-primary-100">
        <div className="col-span-1 text-sm text-slate-700 font-bold">
          Documentation
        </div>
        <a
          className="col-span-3 underline text-left 
          text-secondary-800 break-words active:text-purple-500 ease-linear transition-all duration-150 cursor-pointer bg-transparent text-sm outline-none focus:outline-none"
          href={apiDetail.docUrl || 'http://docs.getos1.com/locateone'}
          target="_blank"
          rel="noreferrer"
        >
          {apiDetail.docUrl || 'http://docs.getos1.com/locateone'}
        </a>
        <CopyText
          value={apiDetail.docUrl || 'http://docs.getos1.com/locateone'}
        />
      </div>
    </div>
  );
};
